import {
    DNO_ADMIN,
    ENA_SYS_ADMIN,
    INSTALLER_ADMIN,
} from "../../../../constants/roles"

type TRoleMap = { [key: string]: string[] }

export const OPENAPI_ROLE_MAPPING: TRoleMap = {
    [DNO_ADMIN]: [
        "/lct/v1/device-protected",
        "/lct/v1/lct-search-protected",
        "/lct/v1/lct-reference",
        "/lct/v1/ttr-reference-protected",
        "/lct/v1/ttr-search-protected",
        "/lct/v1/ttr-deleted-since",
        "/lct/v1/lct-deleted-since",
        "/dno-application/v1/applications",
        "/dno-application/v1/attachment",
        "/dno-application/v1/respond",
        "/dno-application/v1/add-comment",
        "/dno-application/v1/delete-comment",
        "/company-search/v1/company-search",
        "/company-search/v1/company-search-id",
        "/dno-commissioning/v1/respond",
    ],
    [INSTALLER_ADMIN]: [
        "/lct/v1/device",
        "/lct/v1/lct-search",
        "/lct/v1/lct-reference",
        "/lct/v1/ttr-search",
        "/lct/v1/ttr-reference",
        "/lct/v1/ttr-deleted-since",
        "/lct/v1/lct-deleted-since",
        "/upload-attachment/v1/upload",
        "/connection-application/v1/applications",
        "/connection-application/v1/amend",
        "/connection-application/v1/attachment",
        "/connection-application/v1/create",
        "/connection-application/v1/schema",
        "/connection-application/v1/add-comment",
        "/commissioning/v1/submit",
        "/commissioning/v1/launch-form",
    ],
    [ENA_SYS_ADMIN]: ["*"],
}
